export default __webpack_public_path__ + "static/media/downloadApp.7ae7d43b.png";